<i
  #icon
  class="icon"
  [ngClass]="iconClasses"
  [ngStyle]="{
    'height.px': size,
    'width.px': size,
    'background-color': color
  }"
></i>
